module.exports = __webpack_public_path__ + "static/media/survivingForDummiesTY.529d6724.jpeg";